// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { FaShippingFast } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { MapPin } from "lucide-react";
// import DashboardLayout from "../layouts/DashboardLayout";

// /* STATIC MOCK DATA — replace with real API data later */
// const STATIC_ORDERS = [
//   {
//     id: 1,
//     order_number: "CNFDS26-0001",
//     order_status: "shipped",
//     awb_number: "AWB1234567890",
//     shipped_date: "2026-07-28T00:00:00.000Z",
//   },
//   {
//     id: 2,
//     order_number: "CNFDS26-0002",
//     order_status: "confirmed",
//     awb_number: "AWB1234567891",
//     shipped_date: null,
//   },
//   {
//     id: 3,
//     order_number: "CNFDS26-0003",
//     order_status: "delivered",
//     awb_number: "AWB1234567892",
//     shipped_date: "2026-07-20T00:00:00.000Z",
//   },
// ];

// const TrackOrders = () => {
//   const navigate = useNavigate();

//   const [orders] = useState(STATIC_ORDERS);
//   const [page] = useState(1);
//   const [hasNext] = useState(false);
//   const [hasPrev] = useState(false);

//   return (
//      <DashboardLayout>
//     <div
//       className="container-fluid px-0"
//       style={{
//         background: "#fff",
//       }}
//     >
//       <div className="row g-0">
//         <div className="col-12">
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0.4 }}
//             style={{
//               background: "#fff",
//               border: "1px solid #e5e7eb",
//               borderRadius: "12px",
//               overflow: "hidden",
//             }}
//           >
//             {/* HEADER */}

//             <div
//               style={{
//                 padding: "8px 24px",
//                 borderBottom: "1px solid #e5e7eb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//               }}
//             >
//               <FaShippingFast size={15} color="#B8860B" />

//               <h5
//                 style={{
//                   margin: 0,
//                   fontSize: "20px",
//                   fontWeight: "600",
//                   color: "#111827",
//                 }}
//               >
//                 Track Orders
//               </h5>
//             </div>

//             {/* EMPTY */}

//             {orders.length === 0 ? (
//               <div
//                 style={{
//                   height: "260px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   flexDirection: "column",
//                 }}
//               >
//                 <h4
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "600",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   No shipments to track
//                 </h4>

//                 <p
//                   style={{
//                     color: "#6b7280",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Once your orders are shipped, tracking details will appear
//                   here.
//                 </p>
//               </div>
//             ) : (
//               <div
//                 style={{
//                   padding: "10px",
//                 }}
//               >
//                 {orders.map((order) => (
//                   <div
//                     key={order.id}
//                     style={{
//                       border: "1px solid #e5e7eb",
//                       borderRadius: "12px",
//                       padding: "8px",
//                       marginBottom: "6px",
//                       background: "#fff",
//                     }}
//                   >
//                     {/* TOP */}

//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         marginBottom: "8px",
//                         flexWrap: "wrap",
//                         gap: "10px",
//                       }}
//                     >
//                       {/* LEFT */}

//                       <div>
//                         <h6
//                           style={{
//                             fontWeight: "700",
//                             marginBottom: "8px",
//                             fontSize: "14px",
//                             color: "#111827",
//                           }}
//                         >
//                           #{order.order_number}
//                         </h6>

//                         <span
//                           style={{
//                             background:
//                               order.order_status === "Delivered"
//                                 ? "#dcfce7"
//                                 : "#dbeafe",

//                             color:
//                               order.order_status === "Delivered"
//                                 ? "#166534"
//                                 : "#1d4ed8",

//                             padding: "4px 10px",
//                             borderRadius: "30px",
//                             fontSize: "11px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {order.order_status}
//                         </span>
//                       </div>

//                       {/* RIGHT */}

//                       <div
//                         style={{
//                           textAlign: "right",
//                         }}
//                       >
//                         <p
//                           style={{
//                             margin: 0,
//                             fontWeight: "600",
//                             fontSize: "16px",
//                             color: "#111827",
//                           }}
//                         >
//                           Delivery
//                         </p>

//                         <small
//                           style={{
//                             color: "#6b7280",
//                             fontSize: "14px",
//                           }}
//                         >
//                           {order.awb_number}
//                         </small>
//                       </div>
//                     </div>

//                     {/* TRACKING */}

//                     <div
//                       style={{
//                         position: "relative",
//                         margin: "30px 0",
//                       }}
//                     >
//                       {/* LINE */}

//                       <div
//                         style={{
//                           height: "2px",
//                           background: "#e5e7eb",
//                           position: "absolute",
//                           top: "9px",
//                           left: 0,
//                           right: 0,
//                         }}
//                       />

//                       {/* STEPS */}

//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           position: "relative",
//                         }}
//                       >
//                         {["Confirmed", "Shipped", "Delivered", "Returned"].map(
//                           (step, index) => {
//                             const activeIndex =
//                               order.order_status === "confirmed"
//                                 ? 0
//                                 : order.order_status === "shipped"
//                                 ? 1
//                                 : order.order_status === "delivered"
//                                 ? 2
//                                 : order.order_status === "returned"
//                                 ? 3
//                                 : 0;

//                             return (
//                               <div
//                                 key={index}
//                                 style={{
//                                   textAlign: "center",
//                                   flex: 1,
//                                 }}
//                               >
//                                 <div
//                                   style={{
//                                     width: "18px",
//                                     height: "18px",
//                                     borderRadius: "50%",
//                                     background:
//                                       index <= activeIndex
//                                         ? "#c2921c"
//                                         : "#e5e7eb",

//                                     margin: "0 auto",
//                                     border: "3px solid #fff",

//                                     boxShadow:
//                                       index <= activeIndex
//                                         ? "0 0 0 2px #c2921c"
//                                         : "0 0 0 2px #d1d5db",
//                                   }}
//                                 />

//                                 <p
//                                   style={{
//                                     marginTop: "8px",
//                                     fontSize: "11px",
//                                     color:
//                                       index <= activeIndex
//                                         ? "#a16207"
//                                         : "#9ca3af",

//                                     fontWeight: "600",
//                                   }}
//                                 >
//                                   {step}
//                                 </p>
//                               </div>
//                             );
//                           },
//                         )}
//                       </div>
//                     </div>

//                     {/* BOTTOM */}

//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         flexWrap: "wrap",
//                         gap: "12px",
//                       }}
//                     >
//                       <p
//                         style={{
//                           margin: 0,
//                           color: "#6b7280",
//                           fontSize: "12px",
//                         }}
//                       >
//                         {order.shipped_date ? (
//                           <>
//                             📦 Shipped:{" "}
//                             {new Date(order.shipped_date).toLocaleDateString(
//                               "en-GB",
//                             )}
//                           </>
//                         ) : (
//                           <>📦 Not Shipped Yet</>
//                         )}
//                       </p>

//                       <div
//                         style={{
//                           display: "flex",
//                           gap: "10px",
//                         }}
//                       >
//                         <a
//                           href={`https://www.delhivery.com/track-v2/package/${order.awb_number}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           style={{
//                             background: "#c2921c",
//                             color: "#fff",
//                             padding: "8px 16px",
//                             borderRadius: "6px",
//                             textDecoration: "none",
//                             fontSize: "13px",
//                             fontWeight: "600",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "6px",
//                           }}
//                         >
//                           <MapPin size={16} />
//                           Track Live
//                         </a>

//                         <button
//                           onClick={() => navigate(`/orders/${order.id}`)}
//                           style={{
//                             border: "1px solid #d1d5db",
//                             background: "#fff",
//                             padding: "8px 14px",
//                             borderRadius: "6px",
//                             fontSize: "13px",
//                             color: "#111827",
//                             cursor: "pointer",
//                           }}
//                         >
//                           Details
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}

//             <div
//               style={{
//                 padding: "18px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "12px",
//                 borderTop: "1px solid #f3f4f6",
//               }}
//             >
//               <button
//                 disabled={!hasPrev}
//                 style={{
//                   padding: "8px 18px",
//                   borderRadius: "10px",
//                   border: "none",
//                   background: hasPrev ? "#111827" : "#e5e7eb",
//                   color: hasPrev ? "#fff" : "#9ca3af",
//                   fontSize: "13px",
//                   fontWeight: "600",
//                   cursor: hasPrev ? "pointer" : "not-allowed",
//                 }}
//               >
//                 Prev
//               </button>

//               <div
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   color: "#374151",
//                 }}
//               >
//                 Page {page}
//               </div>

//               <button
//                 disabled={!hasNext}
//                 style={{
//                   padding: "8px 18px",
//                   borderRadius: "10px",
//                   border: "none",
//                   background: hasNext ? "#111827" : "#e5e7eb",
//                   color: hasNext ? "#fff" : "#9ca3af",
//                   fontSize: "13px",
//                   fontWeight: "600",
//                   cursor: hasNext ? "pointer" : "not-allowed",
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//     </DashboardLayout>
//   );
// };

// export default TrackOrders;




















import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaShippingFast } from "react-icons/fa";
import { AuthAPI } from "../api/AuthAPI";
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";
import DashboardLayout from "../layouts/DashboardLayout";

const TrackOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);
  const [loading, setLoading] = useState(true);
const statusStyle = (status) => {
  const s = (status || "").toLowerCase();

  switch (s) {
    case "pending":
      return { bg: "#EDE9FE", color: "#5B21B6" };
    case "confirmed":
      return { bg: "#f7dff8", color: "#d81dbf" };
    case "processing":
      return { bg: "#FEF3C7", color: "#D97706" };
    case "shipped":
      return { bg: "#E0E7FF", color: "#4338CA" };
    case "delivered":
      return { bg: "#DCFCE7", color: "#15803D" };
    case "cancelled":
      return { bg: "#FEE2E2", color: "#DC2626" };
    default:
      return { bg: "#F3F4F6", color: "#374151" };
  }
};
  // FETCH ORDERS
  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line
  }, [page]);

  async function fetchOrders() {
    try {
      setLoading(true);

      const res = await AuthAPI.getallpurchase({
        page,
        limit: 6,
      });

      // API returns orders directly under `data`, not `data.data`
      setOrders(res?.data?.data || []);

      const settings = res?.data?.settings || {};

      setHasNext(Boolean(settings.next_page));
      setHasPrev(Boolean(settings.prev_page));
    } catch (err) {
      console.error(err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <DashboardLayout>
      <div
        className="container-fluid px-0 mt-12 md:mt-0"
        style={{
          background: "#fff",
        }}
      >
        <div className="row g-0">
          <div className="col-12">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              {/* HEADER */}

              <div
                style={{
                  padding: "8px 24px",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <FaShippingFast size={15} color="#db2777" />

                <h5
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#111827",
                  }}
                >
                  Track Orders
                </h5>
              </div>

              {/* LOADING */}

              {loading ? (
                <div style={{ padding: "10px" }}>
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      style={{
                        height: "150px",
                        borderRadius: "12px",
                        marginBottom: "6px",
                        background: "#f3f4f6",
                      }}
                      className="animate-pulse"
                    />
                  ))}
                </div>
              ) : orders.length === 0 ? (
                /* EMPTY */
                <div
                  style={{
                    height: "260px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      marginBottom: "8px",
                    }}
                  >
                    No shipments to track
                  </h4>

                  <p
                    style={{
                      color: "#6b7280",
                      fontSize: "14px",
                    }}
                  >
                    Once your orders are shipped, tracking details will
                    appear here.
                  </p>
                </div>
              ) : (
                <div
                  style={{
                    padding: "10px",
                  }}
                >
                  {orders.map((order) => (
                    <div
                      key={order.id}
                      style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        padding: "8px",
                        marginBottom: "6px",
                        background: "#fff",
                      }}
                    >
                      {/* TOP */}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "8px",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {/* LEFT */}

                        <div>
                          <h6
                            style={{
                              fontWeight: "700",
                              marginBottom: "8px",
                              fontSize: "14px",
                              color: "#111827",
                            }}
                          >
                            #{order.order_number}
                          </h6>

                        <span
  style={{
    background: statusStyle(order.order_status).bg,
    color: statusStyle(order.order_status).color,
    padding: "4px 10px",
    borderRadius: "30px",
    fontSize: "11px",
    fontWeight: "600",
    textTransform: "capitalize",
  }}
>
  {order.order_status}
</span>
                        </div>

                        {/* RIGHT */}

                        <div
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              fontWeight: "600",
                              fontSize: "16px",
                              color: "#111827",
                            }}
                          >
                            Delivery
                          </p>

                          <small
                            style={{
                              color: "#6b7280",
                              fontSize: "14px",
                            }}
                          >
                            {order.awb_number}
                          </small>
                        </div>
                      </div>

                      {/* TRACKING */}

                      <div
                        style={{
                          position: "relative",
                          margin: "30px 0",
                        }}
                      >
                        {/* LINE */}

                        <div
                          style={{
                            height: "2px",
                            background: "#e5e7eb",
                            position: "absolute",
                            top: "9px",
                            left: 0,
                            right: 0,
                          }}
                        />

                        {/* STEPS */}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            position: "relative",
                          }}
                        >
                          {[
                            "Confirmed",
                            "Shipped",
                            "Delivered",
                            "Returned",
                          ].map((step, index) => {
                            const activeIndex =
                              order.order_status === "confirmed"
                                ? 0
                                : order.order_status === "shipped"
                                ? 1
                                : order.order_status === "delivered"
                                ? 2
                                : order.order_status === "returned"
                                ? 3
                                : 0;

                            return (
                              <div
                                key={index}
                                style={{
                                  textAlign: "center",
                                  flex: 1,
                                }}
                              >
                                <div
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    borderRadius: "50%",
                                    background:
                                      index <= activeIndex
                                        ? "#db2777"
                                        : "#e5e7eb",

                                    margin: "0 auto",
                                    border: "3px solid #fff",

                                    boxShadow:
                                      index <= activeIndex
                                        ? "0 0 0 2px #db2777"
                                        : "0 0 0 2px #d1d5db",
                                  }}
                                />

                                <p
                                  style={{
                                    marginTop: "8px",
                                    fontSize: "11px",
                                    color:
                                      index <= activeIndex
                                        ? "#be185d"
                                        : "#9ca3af",

                                    fontWeight: "600",
                                  }}
                                >
                                  {step}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* BOTTOM */}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "12px",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            color: "#6b7280",
                            fontSize: "12px",
                          }}
                        >
                          {order.shipped_date ? (
                            <>
                              📦 Shipped:{" "}
                              {new Date(
                                order.shipped_date,
                              ).toLocaleDateString("en-GB")}
                            </>
                          ) : (
                            <>📦 Not Shipped Yet</>
                          )}
                        </p>

                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <a
                            href={
                              order.is_awb_successfully_worked
                                ? `https://www.delhivery.com/track-v2/package/${order.awb_number}`
                                : undefined
                            }
                            target={
                              order.is_awb_successfully_worked
                                ? "_blank"
                                : undefined
                            }
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              if (!order.is_awb_successfully_worked) {
                                e.preventDefault();
                              }
                            }}
                            aria-disabled={!order.is_awb_successfully_worked}
                            title={
                              order.is_awb_successfully_worked
                                ? "Track this shipment live"
                                : "Tracking not available yet"
                            }
                            style={{
                              background: order.is_awb_successfully_worked
                                ? "#db2777"
                                : "#e5e7eb",
                              color: order.is_awb_successfully_worked
                                ? "#fff"
                                : "#9ca3af",
                              padding: "8px 16px",
                              borderRadius: "6px",
                              textDecoration: "none",
                              fontSize: "13px",
                              fontWeight: "600",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              cursor: order.is_awb_successfully_worked
                                ? "pointer"
                                : "not-allowed",
                              pointerEvents: order.is_awb_successfully_worked
                                ? "auto"
                                : "none",
                            }}
                          >
                            <MapPin size={16} />
                            Track Live
                          </a>

                          <button
                            onClick={() => navigate(`/dashboard/purchase-history/order/${order.id}`)}
                            style={{
                              border: "1px solid #d1d5db",
                              background: "#fff",
                              padding: "8px 14px",
                              borderRadius: "6px",
                              fontSize: "13px",
                              color: "#111827",
                              cursor: "pointer",
                            }}
                          >
                            Details
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* PAGINATION */}

              {!loading && orders.length > 0 && (
                <div
                  style={{
                    padding: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    borderTop: "1px solid #f3f4f6",
                  }}
                >
                  <button
                    disabled={!hasPrev}
                    onClick={() => setPage((p) => p - 1)}
                    style={{
                      padding: "8px 18px",
                      borderRadius: "10px",
                      border: "none",
                      background: hasPrev ? "#db2777" : "#e5e7eb",
                      color: hasPrev ? "#fff" : "#9ca3af",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: hasPrev ? "pointer" : "not-allowed",
                    }}
                  >
                    Prev
                  </button>

                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    Page {page}
                  </div>

                  <button
                    disabled={!hasNext}
                    onClick={() => setPage((p) => p + 1)}
                    style={{
                      padding: "8px 18px",
                      borderRadius: "10px",
                      border: "none",
                      background: hasNext ? "#db2777" : "#e5e7eb",
                      color: hasNext ? "#fff" : "#9ca3af",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: hasNext ? "pointer" : "not-allowed",
                    }}
                  >
                    Next
                  </button>
                </div>
              )}
            </motion.div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default TrackOrders;